export const principalFromAccessToken = (token: string): string => {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid database access token');
  }
  const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const claims: unknown = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(payload), char => char.charCodeAt(0))));
  if (
    typeof claims !== 'object' || claims === null ||
    !('iss' in claims) || typeof claims.iss !== 'string' || claims.iss.length === 0 ||
    !('sub' in claims) || typeof claims.sub !== 'string' || claims.sub.length === 0 ||
    !('role' in claims) || claims.role !== 'authenticated'
  ) {
    throw new Error('Invalid database principal claims');
  }
  return JSON.stringify([claims.iss, claims.sub]);
};

export const scopedDatabaseToken = (principal: string, getToken: () => Promise<string>) => async (): Promise<string> => {
  const token = await getToken();
  if (principalFromAccessToken(token) !== principal) {
    throw new Error('Database principal changed before submission');
  }
  return token;
};
